import { Injectable } from '@angular/core';
import { pick } from '@sama/micro-dash';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { SliderTranslationHelper } from '../shapes/slider-rectangle/slider-translation-helper';
import { AbstractTranslationService } from './abstract-translation-service';

@Injectable()
export class SliderRectangleSliderTranslationService extends AbstractTranslationService {
  protected method = 'drag_slider';

  override setUpKeyboardShortcuts() {
    // Matching the nudging used in 3D for smaller pixel precisions.
    const getNudgeDelta = () => (this.store.state().pixelSize > 0.01 ? 5 : 0.1);
    const getSmallNudgeDelta = () =>
      this.store.state().pixelSize > 0.01 ? 1 : 0.01;

    const fastOffsets$ = this.createOffset$(
      {
        leftShortcutName: 'moveSliderLeft',
        rightShortcutName: 'moveSliderRight',
      },
      getNudgeDelta,
    ).pipe(map((delta) => ({ delta })));

    const slowOffsets$ = this.createOffset$(
      {
        leftShortcutName: 'moveSliderLeftSlow',
        rightShortcutName: 'moveSliderRightSlow',
      },
      getSmallNudgeDelta,
    ).pipe(map((delta) => ({ delta, isSmallNudge: true })));
    super.setUpKeyboardShortcuts(
      this.createTranslationHelper$(merge(fastOffsets$, slowOffsets$)),
    );
  }

  protected override getTranslationHelper(_offset: Point2D) {
    return new SliderTranslationHelper(this.injector);
  }

  protected override canTranslate() {
    return super.canTranslate() && this.areAllSelectedShapesSliderRectangles();
  }

  private areAllSelectedShapesSliderRectangles() {
    const selectedShapes = Object.values(
      pick(
        this.store.state().shapes,
        ...Object.keys(this.store.state().selection),
      ),
    );
    return selectedShapes.every((shape) => shape.type === 'slider_rectangle');
  }
}
